@switch(state) {
@case('empty') {
<h3 [dfs]="'t:s1 p-v:2 p-h:20px'">Type to search for matching content</h3>
}
@case('busy') {
<icms-skeleton-loader [numberOfLines]="6"></icms-skeleton-loader>
}
@case('no-results') {
<icms-hint-banner>There are no pages matching search query.</icms-hint-banner>
}
@case('results') {
@for(result of results; track $index){
<h3 [dfs]="'t:s1 p-v:2 p-h:20px'">{{result.title}}</h3>
@for(item of result.items; track item.id){
<button [dfs]="'p-v:2 p-h:19px t:p1'"
        class="_item"
        [class._selected]="isSelected(item)"
        (click)="apply(item)"
        (mouseenter)="select(item)">
    {{item.name}}
    <span [dfs]="'c:14'">{{getItemInfo(item)}}</span>
</button>
}
}
}
}